export default __webpack_public_path__ + "static/media/Orchestraccia.37feb315.jpg";